module.exports = __webpack_public_path__ + "static/media/np.3ce0600c.svg";